import React, {useState} from "react";
import {setPreferredMethod} from "../../../api/requests";
import CardItem from "../../common/items/CardItem";
import {ServerResponse} from "../../../models/models";
import {RESPONSE_TYPES} from "../../../constants";

const PaymentMethodCardRow = ({
                                  paymentMethod, setLoading, handleError,
                                  setServerResponse, allPaymentMethods,
                                  setShouldRefresh
                              }) => {
    const {
        preferredForAC, preferredForVRI, preferredForVDS
    } = paymentMethod || {};

    const [awaitingDeleteConfirm, setAwaitingDeleteConfirm] = useState(false);

    const handleSetPreferredMethodResult = (result) => {
        setLoading(false);
        if (!checkHandleError(result)) {
            setShouldRefresh(val => !val);
        }
    };

    function checkHandleError(result) {
        if (result.status !== 200) {
            console.error('Failed to save payment data');
            handleError(result, i18n.payments.error.genericServerError, setServerResponse);
            return true;
        } else if (result.data.error !== null && result.data.error !== undefined) {
            setServerResponse(new ServerResponse(RESPONSE_TYPES.error, i18n.payments.error.genericTitle,
                result.data.error));
            return true;
        }
        return false;
    }

    const onSetAsPreferredClick = () => {
        setPreferredMethod(null, paymentMethod.paymentMethodId, handleSetPreferredMethodResult);
    };

    const showSetAsPreferredBtn = (!preferredForAC && !preferredForVRI && !preferredForVDS) && !awaitingDeleteConfirm;

    if (!paymentMethod)
        return <></>;

    return (
        <div className={`row payment-method-card-row-div`}>
            <CardItem paymentMethod={paymentMethod}
                      showEditDelete={true}
                      setLoading={setLoading}
                      handleError={handleError}
                      showPreferredTags={true}
                      setServerResponse={setServerResponse}
                      styles={{cursor: 'default'}}
                      allPaymentMethods={allPaymentMethods}
                      setShouldRefresh={setShouldRefresh}
                      awaitingDeleteConfirm={awaitingDeleteConfirm}
                      setAwaitingDeleteConfirm={setAwaitingDeleteConfirm}/>

            <div style={{
                display: "grid", width: "fit-content", verticalAlign: "bottom"
            }}>
                <div style={{height: "fit-content"}}>
                    {
                        preferredForAC && (
                            <div className={`plan-sub-tag ac-plan-header-color`}>
                                <img alt={`videx_logo`}
                                     className={'plan-tag-img'}
                                     src={'../images/videx_logo.png'}/>
                                <span>
                                    {i18n.payments.preferredForAC}
                                </span>
                            </div>
                        )
                    }

                    {
                        preferredForVRI && (
                            <div className={`plan-sub-tag vri-plan-header-color`}>
                                <img alt={`videx_logo`}
                                     className={'plan-tag-img'}
                                     src={'../images/videx_logo.png'}/>
                                <span>
                                    {i18n.payments.preferredForVRI}
                                </span>
                            </div>
                        )
                    }

                    {
                        preferredForVDS && (
                            <div className={`plan-sub-tag vds-plan-header-color`}>
                                <img alt={`videx_logo`}
                                     className={'plan-tag-img'}
                                     src={'../images/videx_logo.png'}/>
                                <span>
                                    {i18n.payments.preferredForVDS}
                                </span>
                            </div>
                        )
                    }
                </div>
                {
                    showSetAsPreferredBtn && (
                        <button type={"button"}
                                className={`button-pay`}
                                onClick={() => onSetAsPreferredClick()}
                                style={{width: "fit-content", height: "fit-content", alignSelf: "end"}}>
                            {i18n.payments.setAsDefault}
                        </button>
                    )
                }
            </div>
        </div>
    );
}

export default PaymentMethodCardRow;